import { render, staticRenderFns } from "./addictedGames.vue?vue&type=template&id=df170e8e&scoped=true"
import script from "./addictedGames.vue?vue&type=script&lang=js"
export * from "./addictedGames.vue?vue&type=script&lang=js"
import style0 from "./addictedGames.vue?vue&type=style&index=0&id=df170e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df170e8e",
  null
  
)

export default component.exports